export const MENU_TYPE_MEGA_MENU = 'mega-menu';
export const DEFAULT_TIMEOUT = 1000;
export const NONPROD_TIMEOUT = 3000;
